/// Stale-chunk recovery sau khi deploy bản mới.
///
/// Lazy-loaded route chunk (vd LoginPage-<hash>.js) đổi hash mỗi lần build. Khi
/// server đã deploy bản mới, file cũ bị xóa → tab đang mở (giữ index.html cũ)
/// fetch chunk 404 → "Failed to fetch dynamically imported module".
///
/// Thay vì tự reload (rủi ro mất dữ liệu form / reload loop), ta bật cờ để
/// App.vue hiện modal cho user chủ động bấm "Tải lại".
import { readonly, ref } from 'vue'
import type { Router } from 'vue-router'

const needsReload = ref(false)

/** Cờ readonly cho App.vue: có cần hiện modal yêu cầu reload không. */
export function useChunkReload() {
  return {
    needsReload: readonly(needsReload),
    reload,
  }
}

/** Full reload để nạp index.html + chunk hash mới. */
function reload(): void {
  window.location.reload()
}

const CHUNK_ERROR_RE =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i

function isChunkLoadError(err: unknown): boolean {
  const message = err instanceof Error ? err.message : String(err ?? '')
  return CHUNK_ERROR_RE.test(message)
}

/**
 * Cài đặt phát hiện stale-chunk: router.onError (lỗi khi navigate, lazy import)
 * + window 'vite:preloadError' (lỗi preload ngoài navigation). Gọi 1 lần ở
 * main.ts sau khi tạo router.
 */
export function installChunkReloadHandler(router: Router): void {
  router.onError((error) => {
    if (isChunkLoadError(error)) needsReload.value = true
  })

  window.addEventListener('vite:preloadError', (event) => {
    // event.payload = lỗi gốc; chặn throw mặc định của Vite, hiện modal thay thế.
    event.preventDefault()
    needsReload.value = true
  })
}
